import { Face } from "@spi/Common/Geometry";
import { Collection } from "./Collection";
import { CompiledGeometryContainer } from "./CompiledGeometryContainer";

export class GeometryContainer {
    public faces: Face[];
    public collection: Collection;
    public reference: string;
    public textureReference: string;
    public type: GeometryType;

    constructor() {
        this.faces = [];
        this.reference = null;
        this.textureReference = null;
        this.type = GeometryType.Generic
    }

    public compile(): CompiledGeometryContainer {
        let collection = new Collection();
        collection.addFaces(this.faces);

        let result = new CompiledGeometryContainer();
        result.reference = this.reference;
        result.textureReference = this.textureReference;
        result.geometry = collection.setCompilationOptions({
            compilationPattern: 'pntl'
        }).compile(true);
        return result;
    }
}

export enum GeometryType {
    Generic = 0,
    Conditional = 1,
    Uncompiled = 2
}